import {
  RatingConfigurator,
  MultipleSelectionConfigurator,
} from '@bingads-webui-campaign-react/survey-factory-tools';

export const CopilotAssetRecommendationSatisfactionSurveyConfig = (options) => {
  const { i18n } = options;

  return {
    featureArea: 'CopilotAssetRecommendationSatisfactionSurvey',
    style: {
      root: {
        maxWidth: 600,
      },
    },
    others: {
      isThankYouPageEnabled: false,
      isUserInitiatedSurvey: true,
      shouldAutoClose: false,
    },
    rating: {
      isRequired: true,
      Type: RatingConfigurator,
      key: 'rating',
      page: 0,
      position: 0,
      getTitle: () => i18n.getString(_TL_('How satisfied are you with the recommended assets for your campaign?')),
      isVisible: () => true,
      options: [
        {
          key: '5',
          text: i18n.getString(_TL_('Very satisfied')),
          rating: 1.0,
        },
        {
          key: '4',
          text: i18n.getString(_TL_('Moderately satisfied')),
          rating: 0.8,
        },
        {
          key: '3',
          text: i18n.getString(_TL_('Neutral')),
          rating: 0.6,
        },
        {
          key: '2',
          text: i18n.getString(_TL_('Moderately dissatisfied')),
          rating: 0.4,
        },
        {
          key: '1',
          text: i18n.getString(_TL_('Very dissatisfied')),
          rating: 0.2,
        },
      ],
    },
    questions: [
      {
        isRequired: true,
        Type: MultipleSelectionConfigurator,
        key: 'q1',
        page: 0,
        position: 1,
        getTitle: () => i18n.getString(_TL_('Please tell us more about why you\'re dissatisfied with recommendations. Select all that apply.')),
        isVisible: answers => ['2', '1'].includes(answers.rating.selectedOption),
        options: [
          {
            key: 'q1o1',
            text: i18n.getString(_TL_('I\'ll need permission from my business or company to use recommended assets.')),
          },
          {
            key: 'q1o2',
            text: i18n.getString(_TL_('The recommendations aren\'t relevant.')),
          },
          {
            key: 'q1o3',
            text: i18n.getString(_TL_('The recommendations aren\'t accurate or up to date. ')),
          },
          {
            key: 'q1o4',
            text: i18n.getString(_TL_('The recommended assets don\'t match the descriptions that I\'ve provided. ')),
          },
          {
            key: 'q1o5',
            text: i18n.getString(_TL_('Other')),
            hasInput: true,
            placeholder: i18n.getString(_TL_('Other')),
          },
        ],
        data: {
        },
      },
    ],
  };
};
